import PropTypes from 'prop-types';
import React from 'react';
import TimeStamp from '../../UI/TimeStamp';

CommentAttribution.propTypes = {
	comment: PropTypes.object,
};

export default function CommentAttribution({ comment }) {
	return (
		<div className="clear text-small relative">
			<span className="name bold">{comment.userAvatar.displayName}</span>
			,&nbsp;
			<span className="org-name">{comment.orgName}</span>
			,&nbsp;
			<span className="italic card-timestamp">
				<TimeStamp timeStamp={comment.updatedDate} />
			</span>
		</div>
	);
}
